import { clsx } from 'clsx';
import type { ElementType, HTMLAttributes, ReactNode } from 'react';

type ContainerSize = 'narrow' | 'default' | 'wide';

type ContainerProps<T extends ElementType = 'div'> = {
  as?: T;
  size?: ContainerSize;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLElement>, 'children'>;

const SIZE_CLASSES: Record<ContainerSize, string> = {
  narrow: 'max-w-3xl',
  default: 'max-w-6xl',
  wide: 'max-w-7xl',
};

export function Container<T extends ElementType = 'div'>({
  as,
  size = 'default',
  className,
  children,
  ...rest
}: ContainerProps<T>) {
  const Component = (as ?? 'div') as ElementType;
  return (
    <Component
      className={clsx('mx-auto w-full px-6 md:px-10 lg:px-12', SIZE_CLASSES[size], className)}
      {...rest}
    >
      {children}
    </Component>
  );
}
